import { render, staticRenderFns } from "./TrustFinalPage.vue?vue&type=template&id=66ca4b42&scoped=true"
import script from "./TrustFinalPage.vue?vue&type=script&lang=js"
export * from "./TrustFinalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca4b42",
  null
  
)

export default component.exports